export interface TemplateLocaleFields {
  supportedCountries?: string[];
  supportedLanguages?: string[];
}

export interface LocaleCodes {
  countryCodes: string[];
  languageCodes: string[];
}

export interface ScopeLocales {
  fgds: LocaleCodes;
  monitoring: LocaleCodes;
}

export function aggregateSupportedLocales(
  fgdsTemplate?: TemplateLocaleFields,
  monitoringTemplate?: TemplateLocaleFields,
): LocaleCodes {
  const countryCodes = [
    ...new Set([...(fgdsTemplate?.supportedCountries ?? []), ...(monitoringTemplate?.supportedCountries ?? [])]),
  ];
  const languageCodes = [
    ...new Set([...(fgdsTemplate?.supportedLanguages ?? []), ...(monitoringTemplate?.supportedLanguages ?? [])]),
  ];
  return { countryCodes, languageCodes };
}

export function getScopeLocales(fgdsTemplate?: TemplateLocaleFields, monitoringTemplate?: TemplateLocaleFields): ScopeLocales {
  return {
    fgds: {
      countryCodes: fgdsTemplate?.supportedCountries ?? [],
      languageCodes: fgdsTemplate?.supportedLanguages ?? [],
    },
    monitoring: {
      countryCodes: monitoringTemplate?.supportedCountries ?? [],
      languageCodes: monitoringTemplate?.supportedLanguages ?? [],
    },
  };
}
